import Validatable from '@/validator/Validatable';

export interface AudienceRecommendationAPI {
  message: string;
}

export default class AudienceRecommendation extends Validatable<AudienceRecommendation> {
  constructor(public segmentIDs: number[] = []) {
    super();
  }

  toApi() {
    return {};
  }

  static fromObject(obj: object) {
    return super.fromObject(obj, new AudienceRecommendation());
  }

  static fromApi(apiObject: AudienceRecommendationAPI) {
    const { message } = apiObject;
    const segmentIDs = [...message.matchAll(/:\*\*\s+{?(\d+)/g)].map((m) => Number(m[1]));
    return new AudienceRecommendation(segmentIDs);
  }
}
